import InputField from "../../Reuseables/Fields/InputField";
import { useFormikContext } from "formik";
import {
  Divider,
  InputAdornment,
  Grid,
  Tooltip,
  Box,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { useState } from "react";
import AddLocalCoordinatorIntro from "../../Reuseables/Introductions/AddLocalCoordinatorIntro";
import { useTranslation } from "react-i18next";
import formModel from "../formModel";
import { Project } from "../../../types/project";

export default function ChooseLCStep() {
  const {
    formField: { localCoordinatorEmail, confirmEmail, skipLocalCoordinator },
  } = formModel;
  const { values, setFieldValue, submitForm } = useFormikContext<Project>();
  const [showEmailField, setShowEmailField] = useState(false);
  const { t } = useTranslation();

  return (
    <Grid
      container
      mt={4}
      sx={{
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
          lg: "row",
        },
      }}
    >
      <Grid item xs>
        <Grid container>
          <Grid item flexGrow={1} />
          <Grid item xs={12} sm={8} md={10} lg={10} xl={8}>
            <AddLocalCoordinatorIntro />
          </Grid>
          <Grid item flexGrow={1} />
        </Grid>
      </Grid>
      <Divider orientation="vertical" flexItem />
      <Grid item xs>
        <Grid container>
          <Grid item flexGrow={1} />
          <Grid
            item
            xs={12}
            sm={8}
            md={10}
            lg={10}
            xl={8}
            sx={{
              "& .MuiBox-root": { mb: 2 },
            }}
          >
            <Grid container>
              <Grid item xs>
                <Box>
                  <Typography>{t("projectWizard.chooseLC")}</Typography>
                </Box>
                <Box>
                  <Stack direction={"row"}>
                    <Button
                      fullWidth
                      variant={"outlined"}
                      onClick={async () => {
                        setShowEmailField(true);
                        setFieldValue(skipLocalCoordinator.name, false);
                      }}
                    >
                      {t("buttons.inviteLC")}
                    </Button>
                    <Tooltip
                      title={skipLocalCoordinator.inviteLocalCoordinator}
                    >
                      <HelpIcon
                        style={{ cursor: "default" }}
                        sx={{ margin: 1 }}
                      />
                    </Tooltip>
                  </Stack>
                </Box>
                <Box>
                  <Stack direction={"row"}>
                    <Button
                      fullWidth
                      variant={"outlined"}
                      onClick={async () => {
                        setShowEmailField(false);
                        setFieldValue(skipLocalCoordinator.name, true);
                        // Hack to wait for new value to get updated
                        await Promise.resolve();
                        submitForm();
                      }}
                    >
                      {t("buttons.skipLC")}
                    </Button>
                    <Tooltip title={skipLocalCoordinator.skipLocalCoordinator}>
                      <HelpIcon
                        style={{ cursor: "default" }}
                        sx={{ margin: 1 }}
                      />
                    </Tooltip>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
            {showEmailField && (
              <Grid container>
                <Grid item xs>
                  <Box mt={4}>
                    <InputField
                      disabled={values.skipLocalCoordinator}
                      name={localCoordinatorEmail.name}
                      label={localCoordinatorEmail.label}
                      placeholder={localCoordinatorEmail.placeholder}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title={localCoordinatorEmail.infoMsg}>
                              <HelpIcon style={{ cursor: "default" }} />
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box>
                    <InputField
                      disabled={values.skipLocalCoordinator}
                      name={confirmEmail.name}
                      label={confirmEmail.label}
                      placeholder={confirmEmail.placeholder}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title={confirmEmail.infoMsg}>
                              <HelpIcon style={{ cursor: "default" }} />
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item flexGrow={1} />
        </Grid>
      </Grid>
    </Grid>
  );
}
